import { createContext } from 'react';
import type { UserContextType } from './UserContext';

// export user context object separately to satisfy fast refresh rule
export const UserContext = createContext<UserContextType | undefined>(undefined);
